import queryString from 'query-string';
var createPagination = function (req, size) {
    if (size === void 0) { size = 10; }
    var count = req.count;
    var next = req.next ? queryString.parseUrl(req.next).query.page : null;
    var current;
    var previous;
    if (req.previous) {
        if (queryString.parseUrl(req.previous).query.page) {
            previous = queryString.parseUrl(req.previous).query.page;
        }
        else {
            previous = 1;
        }
    }
    else {
        previous = null;
    }
    if (previous) {
        if (next) {
            current = next - 1;
        }
        else {
            current = Math.ceil(count / size);
        }
    }
    else {
        current = 1;
    }
    return {
        count: count,
        next: next,
        previous: previous,
        current: current,
    };
};
export default createPagination;
